import More from '@interco/icons/dist/build-v4/orangeds/MD/more'
import Home from '@interco/icons/dist/build-v4/orangeds/MD/home'
import Help from '@interco/icons/dist/build-v4/orangeds/MD/help'
import ArrowLeft from '@interco/icons/dist/build-v4/orangeds/MD/arrow-left'
import Close from '@interco/icons/dist/core/action-navigation/ic_close'
import IcEyeClosed from '@interco/icons/dist/core/action-navigation/ic_eye_closed'
import IcEyeOpen from '@interco/icons/dist/core/action-navigation/ic_eye_open'
import { Text } from '@interco/inter-toranja'
import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import * as S from './styles'

export type HeaderProps = {
  onBackClick: () => void
  rightIcon?: 'house' | 'more' | 'question-mark' | React.ReactNode
  onRightButtonClick?: () => void
  showLeftIcon?: boolean
  title?: string
}

type RightIconProps = Pick<HeaderProps, 'rightIcon' | 'onRightButtonClick'>

const RightIcon = ({ rightIcon, onRightButtonClick }: RightIconProps): JSX.Element => {
  if (typeof rightIcon === 'string') {
    if (rightIcon === 'house')
      return (
        <Home
          data-testid="icon-home"
          color="var(--primary500)"
          onClick={() => onRightButtonClick?.()}
          width={24}
          height={24}
        />
      )
    if (rightIcon === 'more')
      return (
        <More
          data-testid="icon-more"
          color="var(--primary500)"
          onClick={() => onRightButtonClick?.()}
          width={24}
          height={24}
        />
      )
    if (rightIcon === 'eyeClosed')
      return (
        <IcEyeClosed
          data-testid="icon-eye-closed"
          color="var(--color-surface-neutral-strongest)"
          width={24}
          height={24}
        />
      )
    if (rightIcon === 'eyeOpen')
      return (
        <IcEyeOpen
          data-testid="icon-eye-open"
          color="var(--color-surface-neutral-strongest)"
          width={24}
          height={24}
        />
      )
    if (rightIcon === 'question-mark')
      return (
        <Help
          color="var(--color-surface-neutral-strongest)"
          data-testid="icon-help"
          onClick={() => onRightButtonClick?.()}
          width={24}
          height={24}
          style={{ marginLeft: 24 }}
        />
      )
  }

  if (rightIcon) {
    return rightIcon as JSX.Element
  }
  return <div style={{ width: '24px', height: '24px', backgroundColor: 'transparent' }} />
}

export const Header = ({
  onBackClick,
  rightIcon,
  onRightButtonClick,
  showLeftIcon = true,
  title,
}: HeaderProps) => (
  <S.Container>
    {showLeftIcon ? (
      <S.IconButton
        type="button"
        name="left-buttom"
        dir="left-button"
        onClick={onBackClick}
        data-testid="left"
      >
        <ArrowLeft
          color="var(--color-surface-neutral-strongest)"
          width={24}
          height={24}
          data-testid="icon-arrow"
        />
      </S.IconButton>
    ) : (
      <S.IconButton
        type="button"
        name="left-buttom"
        dir="left-button"
        onClick={onBackClick}
        data-testid="left-close"
      >
        <Close
          color="var(--color-surface-neutral-strongest)"
          width={24}
          height={24}
          data-testid="icon-close"
        />
      </S.IconButton>
    )}
    <div style={{ marginLeft: 12, width: '100%' }} data-testid="title-header">
      <Text
        textSize={TextSize.Large}
        textType={TextType.Body}
        textWeight={TextWeight.Bold}
        as="span"
      >
        {title}
      </Text>
    </div>

    {rightIcon && (
      <S.IconButton
        type="button"
        name="left-buttom"
        dir="left-button"
        onClick={onRightButtonClick}
        data-testid="right"
      >
        <RightIcon rightIcon={rightIcon} data-testid="icon-right" />
      </S.IconButton>
    )}
  </S.Container>
)
